// Generated with util/create-component.js
import React from 'react';

import { ITableBodyProps } from './Body.types';

const Body = ({ children }: ITableBodyProps) => (
  <tbody className="rrui-table__body">{children}</tbody>
);
export default Body;
